import { render, staticRenderFns } from "./formArticleClassification.vue?vue&type=template&id=96f09d72&scoped=true&"
import script from "./formArticleClassification.vue?vue&type=script&lang=js&"
export * from "./formArticleClassification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96f09d72",
  null
  
)

export default component.exports